/*
 * @Author: wangshengqiang
 * @Date: 2022-02-28 10:50:30
 * @LastEditTime: 2022-02-28 14:41:27
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import { FormContext } from '@/store/context';
import { createForm, createFormField, formShape } from './rc-form/es';

const Form = ({
  form,
  children
}) => {
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: form
  }, /*#__PURE__*/React.createElement("div", null, children));
};

export { createForm, createFormField, formShape };
export default Form;